export const mcpConnectionsFrCA = {
  title: "Connexions IA",
  description:
    "Les applications que vous avez approuvées pour utiliser votre compte Invup dans {{organization}}. Chacune agit en votre nom, avec votre rôle.",
  approved: "Approuvée : {{date}}",
  lastUsedPrefix: "Dernière utilisation",
  neverUsed: "Jamais utilisée",
  status: {
    active_one: "Active · 1 jour restant",
    active_other: "Active · {{count}} jours restants",
    expiringSoon_one: "Expire dans 1 jour",
    expiringSoon_other: "Expire dans {{count}} jours",
    expiresToday: "Expire aujourd'hui",
    disabledByOrganization: "Désactivée par l'organisation",
    expired: "Expirée",
  },
  expiryNote:
    "Les connexions durent 180 jours à partir de leur approbation. Ensuite, l'application vous demande de l'approuver de nouveau. Une connexion cesse aussi de fonctionner après 30 jours sans utilisation.",
  disconnect: "Déconnecter",
  disconnectAriaLabel: "Déconnecter {{client}}, approuvée le {{date}}",
  confirmTitle: "Déconnecter l'application",
  confirmBody:
    "Voulez-vous vraiment déconnecter {{client}}, approuvée le {{date}}? Elle cesse de fonctionner immédiatement. La prochaine fois que vous l'utiliserez, elle vous demandera de vous connecter de nouveau.",
  confirmBodyExpired:
    "Retirer {{client}}, approuvée le {{date}}, de cette liste?",
  confirmButton: "Déconnecter",
  disconnectError:
    "Désolé, cette connexion n'a pas pu être déconnectée en raison d'une erreur de notre côté. Veuillez réessayer.",
  disconnectedToast:
    "{{client}} a été déconnectée avec succès. Elle vous demandera de vous connecter de nouveau la prochaine fois que vous l'utiliserez.",
  alreadyDisconnectedToast: "{{client}} était déjà déconnectée.",
  loading: "Chargement de vos connexions IA…",
  loadError:
    "Désolé, vos connexions IA n'ont pas pu être chargées en raison d'une erreur de notre côté. Veuillez réessayer.",
  retry: "Réessayer",
  emptyTitle: "Aucune connexion IA pour l'instant",
  emptyBody:
    "Connectez une application d'IA, comme Claude, ChatGPT ou Cursor, pour travailler avec vos entrées de temps, vos projets et vos clients en discutant avec elle. Une connexion ne peut voir ou modifier que ce que votre rôle permet.",
  help: {
    title: "Connecter une application d'IA",
    hint: "Utilisez ces informations pour connecter une autre application. Chaque application vous demande de l'approuver dans votre navigateur.",
    hintEmpty:
      "Utilisez ces informations pour connecter une application. Chaque application vous demande de l'approuver dans votre navigateur.",
    serverUrlLabel: "URL du serveur",
    commandLabel: "Dans Claude Code",
    commandHint: "Exécutez cette commande dans votre terminal.",
    anyClient:
      "Toute application compatible avec MCP (Model Context Protocol) peut se connecter avec l'URL du serveur.",
    requirement:
      "Les connexions IA doivent être activées dans votre organisation.",
    copy: "Copier",
    copied: "Copié",
    serverUrlTarget: "l'URL du serveur",
    commandTarget: "la commande",
    serverUrlCopied: "URL du serveur copiée",
    commandCopied: "Commande copiée",
    copyFailed:
      "Impossible de copier. Sélectionnez le texte et copiez-le plutôt.",
  },
  optedOut: {
    title: "Les connexions IA sont désactivées dans {{organization}}",
    body: "Vos connexions sont suspendues, et non supprimées. Une personne qui gère les intégrations peut les réactiver. Toute connexion inutilisée pendant plus de 30 jours devra être connectée de nouveau.",
    bodyNone:
      "Vous pourrez connecter une application lorsqu'une personne qui gère les intégrations aura réactivé les connexions.",
    bodyManager:
      "Vos connexions sont suspendues, et non supprimées. Vous pouvez les réactiver dans les paramètres des connexions IA. Toute connexion inutilisée pendant plus de 30 jours devra être connectée de nouveau.",
    bodyManagerNone:
      "Vous pourrez connecter une application lorsque les connexions seront réactivées. Vous pouvez le faire dans les paramètres des connexions IA.",
    manageLink: "Aller aux paramètres des connexions IA",
  },
  featureRequired: {
    title: "Les connexions IA nécessitent le forfait Pro",
    body: "{{organization}} n'utilise pas le forfait Pro, donc vos connexions sont suspendues, et non supprimées. Demandez au propriétaire de votre organisation de passer au forfait supérieur. Toute connexion inutilisée pendant plus de 30 jours devra être connectée de nouveau.",
    bodyNone:
      "{{organization}} n'utilise pas le forfait Pro, donc aucune application d'IA ne peut encore être connectée. Demandez au propriétaire de votre organisation de passer au forfait supérieur.",
    bodyBilling:
      "{{organization}} n'utilise pas le forfait Pro, donc vos connexions sont suspendues, et non supprimées. Toute connexion inutilisée pendant plus de 30 jours devra être connectée de nouveau.",
    bodyBillingNone:
      "{{organization}} n'utilise pas le forfait Pro, donc aucune application d'IA ne peut encore être connectée.",
    upgrade: "Passer à Pro",
  },
  unavailable: {
    title: "Les connexions IA sont temporairement indisponibles",
    body: "Invup a suspendu les connexions IA pour toutes les organisations. Vos connexions sont conservées et fonctionneront de nouveau dès le retour du service. Toute connexion inutilisée pendant plus de 30 jours devra être connectée de nouveau.",
    bodyNone:
      "Invup a suspendu les connexions IA pour toutes les organisations. Réessayez de vous connecter plus tard.",
  },
};
